<template>
  <div class="bounty-row bounty-grid" v-on:click="giftSub">
    <span class="bounty-grid__rank">{{ rank }}</span>
    <div class="bounty-row__user">
      <user :user_id="subBounty.user_id"></user>
    </div>
    <span class="bounty-grid__amount">{{ formatCurrency(subBounty.amount) }}</span>
    <div class="bounty-grid__action">
      <button class="sl-btn sl-btn--ghost sl-btn--sm">{{ btnLabel }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bounty',
  props: {
    subBounty: {
      type: Object,
      required: true
    },
    tier: {
      type: Number,
      default: 1
    },
    rank: {
      type: Number,
      default: 0
    },
    btnLabel: {
      type: String,
      default: 'Gift Sub'
    }
  },
  methods: {
    giftSub () {
      window.open(
        `https://www.twitch.tv/products/swiftor${this.tier === 2 ? '_2000' : this.tier === 3 ? '_3000' : ''}?recipient=${this.users[this.subBounty.user_id].twitch_name}`
      )
    }
  },
  data () {
    return {
      users: this.$store.state.users
    }
  }
}
</script>

<style scoped>
.bounty-row {
  padding-top: 13px;
  padding-bottom: 13px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background-color 0.12s;
  cursor: pointer;
}

.bounty-row:last-child {
  border-bottom: none;
}

.bounty-row:hover {
  background: rgba(255, 255, 255, 0.025);
}

.bounty-row__user {
  min-width: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Bounty.vue